import * as React from "react";
const termsData = [{
  title: "DSGVO-Konformitätserklärung",
  content: "SecureNetics verpflichtet sich zum Schutz Ihrer Privatsphäre. Wir verarbeiten personenbezogene Daten streng nach den Vorgaben der EU-Datenschutz-Grundverordnung (DSGVO) sowie des Bundesdatenschutzgesetzes (BDSG). Unsere Systeme sind darauf ausgelegt, ein Höchstmaß an Datensicherheit und Transparenz für unsere Nutzer zu gewährleisten."
}, {
  title: "Datenerhebung und -verarbeitung",
  content: "Wir erheben Daten wie Name, E-Mail-Adresse, IP-Adresse und Nutzungsverhalten. Dies geschieht über Kontaktformulare, Cookies und Analysetools. Die Rechtsgrundlage bildet Art. 6 Abs. 1 DSGVO (Einwilligung, Vertragserfüllung oder berechtigtes Interesse). Ohne diese Daten können wir unsere spezialisierten Sicherheitsdienste nicht vollumfänglich bereitstellen."
}, {
  title: "Zwecke der Datenverarbeitung",
  content: "Ihre Daten werden ausschließlich für folgende Zwecke genutzt: Bereitstellung unserer Sicherheitslösungen, technischer Support, Marketing (nur mit Opt-in), Betrugsprävention sowie zur Erfüllung gesetzlicher Aufbewahrungspflichten. Eine Weitergabe an Dritte erfolgt nur im Rahmen notwendiger Auftragsverarbeitungen."
}, {
  title: "Ihre Rechte als Nutzer",
  content: "Sie haben das Recht auf Auskunft, Berichtigung, Löschung ('Recht auf Vergessenwerden') und Einschränkung der Verarbeitung. Zudem steht Ihnen das Recht auf Datenübertragbarkeit und ein Widerspruchsrecht gegen die Verarbeitung zu. Einwilligungen können Sie jederzeit mit Wirkung für die Zukunft widerrufen."
}, {
  title: "Datenaufbewahrung",
  content: "Wir speichern Kundendaten für die Dauer der Geschäftsbeziehung plus 6 Jahre gemäß steuerrechtlicher Vorgaben. Marketingdaten werden bis zu Ihrem Widerruf gespeichert. Server-Logfiles und Sicherheitsdaten werden aus Sicherheitsgründen für maximal 90 Tage aufbewahrt und anschließend automatisiert gelöscht."
}, {
  title: "Cookie-Richtlinie",
  content: "Unsere Website verwendet essenzielle Cookies für den Betrieb, Analyse-Cookies zur Reichweitenmessung und Marketing-Cookies für personalisierte Inhalte. Über unser Consent-Management-Tool können Sie Ihre Präferenzen jederzeit individuell anpassen und nicht notwendige Cookies deaktivieren."
}, {
  title: "Sicherheitsmaßnahmen",
  content: "Zum Schutz Ihrer Daten setzen wir modernste technische und organisatorische Maßnahmen (TOM) ein. Dazu gehören End-to-End-Verschlüsselung, strikte Zugriffskontrollen und regelmäßige externe Sicherheitsaudits. Unsere Infrastruktur wird kontinuierlich auf Schwachstellen überwacht."
}, {
  title: "Datenschutz-Kontakt",
  content: "Bei Fragen zum Datenschutz wenden Sie sich bitte an datenschutz@securenetics.de. Unser Datenschutzbeauftragter steht Ihnen für alle Anfragen zur Verfügung. Wir verpflichten uns, alle datenschutzrechtlichen Anfragen innerhalb der gesetzlichen Frist von 30 Tagen zu bearbeiten."
}];
export default function TermsAndConditions() {
  return <section data-section-id="244237" id="datenschutz-compliance" className="bg-background text-foreground py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 md:px-6 max-w-3xl">
        <div className="mb-12 text-center md:text-left">
          <h1 className="text-3xl md:text-5xl font-bold text-foreground font-default mb-4 tracking-tight">
            Datenschutz & Compliance
          </h1>
          <p className="text-muted-foreground text-base font-default">
            Stand der Richtlinien: {new Date().toLocaleDateString("de-DE")}
          </p>
        </div>

        <div className="space-y-10">
          {termsData.map((section, index) => <div data-index={index} key={index} className="flex flex-col md:flex-row gap-4 md:gap-6">
              <div className="shrink-0">
                <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary text-primary-foreground font-bold text-lg font-default shadow-sm">
                  {index + 1}
                </span>
              </div>
              <div>
                <h2 className="text-xl font-bold text-foreground font-default mb-3 tracking-tight">
                  {section.title}
                </h2>
                <p className="text-base text-foreground/80 leading-relaxed font-default">
                  {section.content}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}